import script from "./QuestionListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionListItem.vue?vue&type=script&setup=true&lang=js"

import "./QuestionListItem.vue?vue&type=style&index=0&id=506925d4&lang=less"

const __exports__ = script;

export default __exports__